import React, { Component } from 'react';
import footerLogo from '../Asset/app/media/img/logos/nexdigm-logo-sm.png'
import { Row, Col } from 'react-bootstrap';

export class Footer extends Component {
    static displayName = Footer.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            role: '',
            token: '',
            url: ''
        };
        this.state.role = localStorage.getItem('role');
        this.state.token = localStorage.getItem('token');
        this.state.url = localStorage.getItem('remitterCode');
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }


    render() {
        return (
            <div className="m-grid__item	m-footer " style={{ width:"100%" }}>
                <div className="m-container m-container--fluid m-container--full-height m-page__container">
                    <Row>
                        <Col md={9}>
                            <span className="m-footer__copyright">
                                *For any issues/queries contact us at <a className="email_footer" href="mailto:dividend.support@nexdigm.com">dividend.support@nexdigm.com</a>
                                </span>
                        </Col>
             
                        <Col md={3} className="pull-right">
                            <span className="m-footer__copyright pull-right">
                                <a href="https://www.nexdigm.com/"><img src={footerLogo} /></a>
                            </span>
                        </Col>
                    </Row>

                </div>
            </div>

        );
    }
}
